import { yupDateRangeValidation } from '@product-framework/components/FormFields';
import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      claimNumber: yup
        .string()
        .nullable()
        .test(
          'claimNumber-min-length',
          formatMessage({
            id: 'CLAIM_NUNBER_MIN_LENGTH',
            defaultMessage: 'Claim Number must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      claimStatusDate: yupDateRangeValidation({
        testName: 'claimStatusDate-value=required-on-operator',
        sameErrMessage: 'Claim Status dates cannot be same for between',
        greaterThnErrMessage:
          'Claim Status date start needs to be greater than end date',
        validBetweenDateMessage:
          'Claim Status date must have 2 valid dates for between',
        requiredMessage: 'Claim Status date is required',
        validDateMessage: 'Claim Status date should be valid date',
      }),
      createdDateTime: yupDateRangeValidation({
        testName: 'createdDateTime-value=required-on-operator',
        sameErrMessage: 'Claim created dates cannot be same for between',
        greaterThnErrMessage:
          'Claim created date start needs to be greater than end date',
        validBetweenDateMessage:
          'Claim created date must have 2 valid dates for between',
        requiredMessage: 'Claim created date is required',
        validDateMessage: 'Claim created date should be valid date',
      }),
      approvedDateTime: yupDateRangeValidation({
        testName: 'approvedDateTime-value=required-on-operator',
        sameErrMessage: 'Claim approved dates cannot be same for between',
        greaterThnErrMessage:
          'Claim approved date start needs to be greater than end date',
        validBetweenDateMessage:
          'Claim approved date must have 2 valid dates for between',
        requiredMessage: 'Claim approved date is required',
        validDateMessage: 'Claim approved date should be valid date',
      }),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
